export const sandboxDemoKeys = {
  all: ['sandbox-demo'] as const,
  roster: ['sandbox-demo', 'roster'] as const,
};
